export default __webpack_public_path__ + "static/media/info.09fe632b.svg";